// extracted by mini-css-extract-plugin
module.exports = {"textarea":"index-textarea__1w-UO","textarea_error":"index-textarea_error__z0rLg"};